import { BorderRadius, Positioning, PurpleLight, Spacing } from "@bonusx-global/bx-design-system";
import styled from "@emotion/styled";
import Box from "@mui/material/Box";

export const AiChatbotIconContainer = styled(Box)({
  borderRadius: BorderRadius.full,
  backgroundColor: PurpleLight.main,
  padding: Spacing["500"],
  color: PurpleLight.contrastText,
  height: Spacing["2500"],
  maxWidth: "fit-content",
  position: Positioning.relative,
});
